import React, { Profiler, useContext } from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { getHostCURL } from '../../common/utils/cardUtils';
import * as localData from '../../core/Constants';
import './SpendSummary.scss';
import { DataContext } from '../../contexts';
import * as CurrencyUtils from '../../common/utils/CurrencyUtils';

const ToolTipContent = React.forwardRef(() => {
  const termLink = getHostCURL('/c/ProXtra_TermsandConditions');
  return (
    <div className="LoyaltySummary__toolTipLabel">
      <p>{localData.spendToolTipLabel}</p>
      <p> {localData.spendToolTipLabel1}</p>
      <br />
      <p>{localData.spendToolTipLabel2}</p>
      <p>{localData.spendToolTipLabel3}</p>
      <br />
      <p>
        For full details, see the&nbsp;
        <a href={termLink} className="u__default-link" rel=" noreferrer">
          Pro Xtra Program Terms &amp; Conditions
        </a>
      </p>
    </div>
  );
});

const ToolTip = () => {
  return (
    <Profiler id="overview" onRender={() => {}}>
      <Tooltip channel="desktop" content={<ToolTipContent />} interactive>
        <span><Image
          className="LoyaltySummary__infoLogo"
          src="https://assets.thdstatic.com/images/v1/loyaltyBenefits/ProTiers/icon-info.svg"
          alt="info-icon"
        />
        </span>
      </Tooltip>
    </Profiler>
  );
};

export const SpendSummary = () => {
  const { userData } = useContext(DataContext);
  const proXtraSpend = userData && userData?.proXtraSpend;
  const spendAmount = proXtraSpend?.totalCurrentYearSpend || '0';
  const savingsAmount = parseInt(proXtraSpend?.totalCurrentYearSavings, 10) || '0';
  const totalCurrentYearSavings = proXtraSpend?.totalCurrentYearSavings || '0';
  return (
    <div>
      <div className="col__8-12 LoyaltySummary__spendSummaryHeader">
        <div className={savingsAmount > 0 ? 'LoyaltySummary__summaryLine' : 'LoyaltySummary__noSummaryLine '}>
          <div className="LoyaltySummary__spendAmount">
            <p className="LoyaltySummary__SingleFirstLine">
              ${spendAmount}
            </p>
          </div>
          <div className="LoyaltySummary__spendLabel">Pro Xtra Loyalty Spend
            <ToolTip />
          </div>
        </div>
      </div>
      {savingsAmount > 0
      && (
        <div className="col__4-12">
          <div className="LoyaltySummary__summarySaving">
            <div className="LoyaltySummary__savingAmount">
              ${totalCurrentYearSavings}
            </div>
            <div className="LoyaltySummary__spendLabel">Savings</div>
          </div>
        </div>
      ) }
    </div>
  );
};
